import { ReactNode } from 'react';

export type RowType = Record<string, unknown>;

// Pending changes of generic row type, R.
export interface PendingChanges<R> {
  editedRows?: R[];
  newRows?: R[];
  deletedRows?: R[];
}

export const displayValue = (val: unknown): string => {
  if (val == null) return 'null';
  if (typeof val === 'object') return JSON.stringify(val);
  return String(val);
};

// Renderer may return Date, which React can't render directly.
export const renderValue = (val: Date | ReactNode) => {
  if (val instanceof Date) return val.toLocaleDateString();
  return val;
};

const toTokens = (val: unknown): string[] => {
  if (Array.isArray(val)) return val.map(String);
  if (typeof val === 'string') return val.split(/[,;\s]+/).filter(Boolean);
  return [];
};

const TokenDiff = ({ oldVal, newVal }: { oldVal: unknown; newVal: unknown }) => {
  const oldTokens = toTokens(oldVal);
  const newTokens = toTokens(newVal);
  const removed = oldTokens.filter(t => !newTokens.includes(t));
  const added = newTokens.filter(t => !oldTokens.includes(t));
  return (
    <>
      {removed.map((val, i) => (
        <div key={`removed-${i}-${val}`} className='old-val'>
          - {val}
        </div>
      ))}
      {added.map((val, i) => (
        <div key={`added-${i}-${val}`} className='new-val'>
          + {val}
        </div>
      ))}
    </>
  );
};

// Factory that returns a `diffRenderer` for a column whose field is a multi-value
// string or array. Renders removed tokens as `- value` and added tokens as `+ value`
export function tokenDiffRenderer<R extends RowType>(field: keyof R) {
  function diffRender({ oldRow, newRow }: { oldRow: R; newRow: R }): ReactNode {
    return <TokenDiff oldVal={oldRow[field]} newVal={newRow[field]} />;
  }
  return diffRender;
}
